import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { getTransaction } from "~/graphql/queries";
import { LoaderData } from "~/types";

export const EMPTY_TRANSACTION: APITypes.Transaction = {
  __typename: "Transaction",
  id: "",
  tenantID: "",
  managerID: "",
  createdAt: "",
  updatedAt: "",
  status: APITypes.PaymentStatusType.Pending,
  amount: 0,
  entityID: "",
  entityType: "",
  month: 0,
  year: 0,
  reason: APITypes.TransactionReason.Rent,
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getTransactionDetails = async (
  transactionID: string
): Promise<LoaderData<APITypes.Transaction>> => {
  try {
    const response = (await API.graphql({
      query: getTransaction,
      variables: {
        id: transactionID,
      },
    })) as { data?: APITypes.GetTransactionQuery };

    if (!response.data?.getTransaction) {
      throw new Error("No transaction found");
    }

    return {
      success: true,
      data: response.data?.getTransaction || EMPTY_TRANSACTION,
    };
  } catch (error) {
    console.error("failed to get transaction details", error);
    return {
      success: false,
      data: EMPTY_TRANSACTION,
      error,
    };
  }
};
